module.exports = __webpack_public_path__ + "img/WeChat0b6aed909c84497ab4c2c853137026e4.0b6aed90.png";